import { render, staticRenderFns } from "./RealTaskTab.vue?vue&type=template&id=c6807d36&"
import script from "./RealTaskTab.vue?vue&type=script&lang=js&"
export * from "./RealTaskTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports